export class SurveyDeployerWCPageRequestJSON {
    contextEntityId: Number;
    contextInstanceId: Number;
    tenantId: Number;
    organizationId: Number;
    editable_true: boolean;
    userID: Number;
    link: String;
    roleID: Number;
    sysSurveyRunID: Number;
    isHistorical: boolean;
}